module.exports = __webpack_public_path__ + "img/ItemActive.bf9be3e3.svg";